import type { ReactNode } from 'react';
import { Stack, Text } from '@mantine/core';

interface DetailStatBoxProps {
  label: string;
  value: ReactNode;
}

export const DetailStatBox = ({ label, value }: DetailStatBoxProps) => (
  <Stack
    gap={8}
    p={18}
    justify="center"
    style={{
      borderRadius: 12,
      border: '1px solid var(--color-border-soft)',
      backgroundColor: 'var(--color-bg-surface)',
      minWidth: 160,
      flex: '1 0 auto'
    }}
  >
    <Text
      fz={11}
      fw={600}
      tt="uppercase"
      style={{ color: 'var(--color-text-muted)', letterSpacing: 0.4, whiteSpace: 'nowrap' }}
    >
      {label}
    </Text>
    {typeof value === 'string' ? (
      <Text fz={18} fw={700} style={{ color: 'var(--color-text-primary)', whiteSpace: 'nowrap' }}>
        {value}
      </Text>
    ) : (
      value
    )}
  </Stack>
);
